import storeInfo from 'src/ducks/store'

export const getCampaigns = () => (): any => {
  const { campaigns } = storeInfo.store.getState()
  // if (!orderMaintenance) return null
  return campaigns
}
